import i18n from '@/i18n';

/**
 * Return object with all status flags for given Device.
 */
export function getDeviceStatusObject(device) {
  return {
    contentIsNotUpToDate:
      !device.content_updated && !device.online && device.first_activation,
    contentIsSyncing:
      !device.content_updated && device.online && device.first_activation,
    inShipping: !device.first_activation && device.in_shipping,
    offline: !device.online && device.first_activation,
    online: device.online && device.first_activation,
    waitingForComissioning: !device.first_activation && !device.in_shipping,
  };
}

/**
 * Return translated status message for a given Device status field/key.
 */
function getDeviceStatusMessageForKey(statusKey) {
  return {
    contentIsNotUpToDate: i18n.t('contentIsNotUpToDate'),
    contentIsSyncing: i18n.t('contentIsSyncing'),
    inShipping: i18n.t('deviceInShipping'),
    offline: i18n.t('offline'),
    online: i18n.t('online'),
    waitingForComissioning: i18n.t('deviceWaitingForComissioning'),
  }[statusKey];
}

/**
 * Return combined status messages as one string.
 *
 * This can be used to match the Device against search terms.
 */
export function getDeviceStatusSearchableText(device) {
  let text = '';
  const statusObject = getDeviceStatusObject(device);
  for (const statusKey of Object.keys(statusObject)) {
    const hasStatus = statusObject[statusKey];
    if (!hasStatus) {
      continue;
    }
    const statusMessage = getDeviceStatusMessageForKey(statusKey);
    text += ' ' + statusMessage;
  }
  return text;
}



// WEBPACK FOOTER //
// ./src/mixins/deviceStatus.js